import { Card } from "@nabble/ui";
import type { AccountInfo } from "../../../../api/account";
import { AuthenticatorAppRow } from "./AuthenticatorAppRow";
import { PasskeysRow } from "./PasskeysRow";
import { RecoveryCodesRow } from "./RecoveryCodesRow";

/** My account → Authentication → second factor: authenticator app, passkeys and recovery codes. */
export function SecondFactorCard({ account, onChanged }: { account: AccountInfo; onChanged: () => void }): React.JSX.Element {
  return (
    <Card id="security" className="nb-setting" padded={false}>
      <AuthenticatorAppRow enabled={account.totp} onChanged={onChanged} />
      <PasskeysRow passkeys={account.passkeys} onChanged={onChanged} />
      <RecoveryCodesRow remaining={account.recoveryCodesRemaining} onChanged={onChanged} />
    </Card>
  );
}
